var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff8c08",
    height: "800px",
    width: "800px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    stroke: "#ff8c08",
    strokeWidth: 0.032,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6,9.2l-9-7c-0.3-0.3-0.8-0.3-1.2-0.1L8.7,9H3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4v5H3c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1h10 c0.6,0,1-0.4,1-1v-5c0-0.6-0.4-1-1-1H9v-5c0,0,0,0,0,0c0,0,0,0,0,0h8v14.5l-3.6,2.7c-0.3,0.3-0.5,0.7-0.3,1.1 c0.1,0.4,0.5,0.7,0.9,0.7h12c0.4,0,0.8-0.3,0.9-0.7c0.1-0.4,0-0.9-0.3-1.1L23,25.5V11h6c0.4,0,0.8-0.3,0.9-0.7 C30.1,9.9,30,9.5,29.6,9.2z M5.9,18L4,20.4V18H5.9z M8,18.6L9.9,21H6.1L8,18.6z M12,20.4L10.1,18H12V20.4z M19,4.8V9h-1h-5.6L19,4.8 z M22,9h-1V5l5.1,4H22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopments);
export default __webpack_public_path__ + "static/media/developments.24fe78aa2899648452d0f42a1f1fb9a0.svg";
export { ForwardRef as ReactComponent };